import { Card, SkeletonBodyText } from "@medentic/polaris-react";
import { Patient } from "../../types";

interface AppointmentsTabContentProps {
  patient?: Patient;
  loading?: boolean;
}

function AppointmentsTabContent({
  patient,
  loading,
}: AppointmentsTabContentProps) {
  if (loading) {
    return (
      <Card>
        <SkeletonBodyText lines={10} />
      </Card>
    );
  }

  return <Card>{patient?.core_appointments}</Card>;
}

export default AppointmentsTabContent;
